import API from '../API';

export const getColors = id => API.get(`/sku/colors/${id}`);

export const getShapes = id => API.get(`/sku/sizes/${id}`);

export const postImage = (id, file) => API.post('/sku/uploadIcon', { id, file });
